import React from 'react';

const ArrowDownIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 2L5.42667 5.57333C5.40348 5.59655 5.37594 5.61498 5.34563 5.62755C5.31531 5.64012 5.28282 5.64658 5.25 5.64658C5.21718 5.64658 5.18469 5.64012 5.15437 5.62755C5.12406 5.61498 5.09652 5.59655 5.07333 5.57333L1.5 2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowDownIcon; 